import React, { useState, useEffect } from 'react';
import { BootstrapDialog } from '../../../../assets/style/globalStyle';
import { NotificationManager } from 'react-notifications';
import { viaCep, validCep, validEmail } from '../../../../@core/utils/utilsFunctions';
import { isMobile } from 'react-device-detect';
import { validateCPF } from '../../../../@core/utils/utilsFunctions';
import { useSelector } from 'react-redux';
import { selectLogin, selectClient } from '../../../../store/login/loginSlice';
import {
  Stack,
  IconButton,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  Autocomplete,
  InputAdornment
} from '@mui/material';

import Iconify from '../../../../@core/theme/Iconify';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';
import configAxios from '../../../../services/configAxios';

/**
 * id_type_client === 1 - Físico
 * id_type_client === 2 - Júridico
 *
 */

const addClientsDependents = (props) => {
  const [infosDeps, setInfosDeps] = useState({});
  const [initialInfosDeps, setInitialInfosDeps] = useState({});
  const [infosDepsList, setInfosDepsList] = useState([]);
  const [infosWaitingPeriod, setInfosWaitingPeriod] = useState([]);
  const [infosAdressTit, setAdressTit] = useState({});
  const [infosOrgaEmissor, setInfosOrgaEmissor] = useState([]);
  const [salesValue, setSalesValue] = useState(infosDeps.valclient || '');
  const infoStateTemp = useSelector(selectLogin);
  const [infoState] = useState({ ...infoStateTemp.userLoggedIn[0] });
  const [infosTablesTemp, setInfosTablesTemp] = useState([]);
  const [cpfBuscado, setCpfBuscado] = useState('');
  const company = useSelector(selectClient);

  useEffect(() => {
    getInfosOrgaoEmissor();
    getWaitingPeriod();
    setInfosTablesTemp(props.infosTables);
    if (props.otherInfos.id_type_client === 2) {
      getDepsHolder();
    }
  }, []);

  useEffect(() => {
    setInfosDeps(props.infosDepsEdit[0] ? props.infosDepsEdit[0] : {});
    setInitialInfosDeps(props.infosDepsEdit[0] ? props.infosDepsEdit[0] : {});

    setAdressTit(
      props.infosDepsTit[0]
        ? {
            ...props.infosDepsTit[0],
            labelDeps: props.infosDepsTit[0].id + ' - ' + props.infosDepsTit[0].nome
          }
        : {}
    );
    if (props.infosDepsEdit[0]) {
      setCpfBuscado(props.infosDepsEdit[0].cpf_cnpj);
    }
  }, [props.infosDepsEdit, props.infosDepsTit]);

  function getInfosOrgaoEmissor() {
    configAxios
      .get('utilsInfos/getInfosOrgaoEmissor')
      .then((response) => {
        setInfosOrgaEmissor(response.data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para buscar as informações do RG! Tente novamente!',
          'Atenção'
        );
      });
  }

  function getDepsHolder() {
    configAxios
      .get(`/clients/getInfosHolder/${props.otherInfos.id}`)
      .then((response) => {
        setInfosDepsList(response.data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para listar os titulares para seleção, tente novamente!',
          'Atenção'
        );
      });
  }

  async function getWaitingPeriod() {
    await configAxios
      .get(`/waitiginPeriod/getWaitingPeriod`)
      .then((response) => {
        setInfosWaitingPeriod(response.data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para buscar as informações das tabelas! Tente novamente!',
          'Atenção'
        );
      });
  }

  function HandleAdressTit(value) {
    if (value) {
      setInfosDeps({ ...infosDeps, id_tit: value.id, labelDeps: value.label });
      setAdressTit({ ...infosAdressTit, ...value });
    } else {
      setInfosDeps({ ...infosDeps, id_tit: undefined, labelDeps: '' });
      setAdressTit('');
    }
  }

  function HandleInputChange(event, params = {}) {
    if (params.autocomplete) {
      if (event) {
        setInfosDeps({ ...infosDeps, label: event.label, id_orgao: event.id });
      }
      return;
    }
    if (params.cep) {
      setInfosDeps({ ...infosDeps, ...params.cep });
      return;
    }
    if (params.codcarencia) {
      if (event) {
        setInfosDeps({ ...infosDeps, labelcarencia: event.label, codcarencia: event.codcarencia });
      }
      return;
    }

    if (params.plan) {
      if (event) {
        const infosTablesTemp = props.infosTables.filter(
          (element) => element.codplano === event.codplano
        );
        setInfosTablesTemp([]);
        infosTablesTemp.unshift({ id: '', label: '' });
        setInfosTablesTemp(infosTablesTemp);
        infosDeps.labeltables = '';
        setSalesValue('');
        infosDeps.codtab = '';

        setSalesValue('');
        infosDeps.codtab = '';

        infosDeps.valclient = '';

        setInfosDeps({
          ...infosDeps,
          labelplans: event.label,
          codplano: event.codplano
        });
      }
      return;
    }

    if (params.table) {
      if (event) {
        setInfosDeps({ ...infosDeps, labeltables: event.label, codtab: event.codtab });
        setSalesValue('');
        infosDeps.valclient = '';
      }
      return;
    }
    if (event.target.name === 'dtnascimento') {
      if (event.target.value > new Date()) {
        NotificationManager.warning('Data de nascimento inválida, verifique!', 'Atenção');
        return;
      }
      if (company === 'gocare') {
        if (
          calcularIdade(event.target.value) < 10 &&
          (infosDeps.tpbenef === 'Titular' ||
            infosDeps.tpbenef === 'Titular menor' ||
            infosDeps.tpbenef === undefined ||
            infosDeps.tpbenef === null ||
            infosDeps.tpbenef === '')
        ) {
          NotificationManager.warning(
            'Não é possível realizar a venda para beneficiários titulares abaixo de 10 anos!',
            'Atenção'
          );
          infosDeps.dtnascimento = '';
          setInfosDeps({ ...infosDeps, dtnascimento: null });
          return;
        }
      }
      infosDeps.valclient = '';
      setSalesValue('');
    }
    if (event.target.name === 'tpbenef') {
      delete infosDeps.id_tit;
      setAdressTit('');
      infosDeps.labelDeps = '';
    }

    if (event.target.name === 'email') {
      event.target.value = event.target.value.toLowerCase();
    }
    setInfosDeps({ ...infosDeps, [event.target.name]: event.target.value });
  }

  async function HandleInputCep(event) {
    if (event) {
      if (event.target.value) {
        if (validCep(event.target.value)) {
          let infosCep;
          infosCep = await viaCep(event.target.value);
          if (infosCep) {
            if (infoState.controlaregiao === 'Sim') {
              const validMun = await getCitiesOfRegion(props.otherInfos.id_regiao, infosCep.cidade);
              if (validMun) {
                HandleInputChange(event, { cep: infosCep });
                return;
              } else {
                setInfosDeps({
                  ...infosDeps,
                  cep: '',
                  rua: '',
                  bairro: '',
                  cidade: '',
                  estado: '',
                  codibge: ''
                });
                NotificationManager.warning(
                  'O múnicipio do cep digitado não faz parte da região selecionada, por favor, verifique!',
                  'Atenção'
                );
                return;
              }
            } else {
              HandleInputChange(event, { cep: infosCep });
              return;
            }
          }
          NotificationManager.danger(
            'Tivemos dificuldades para buscar as informações do endereço, tente novamente!',
            'Atenção'
          );
        } else {
          NotificationManager.warning('Cep inválido, verifique e tente novamente!', 'Atenção');
        }
      }
    }
  }

  async function getCitiesOfRegion(idregiao, nomemun) {
    try {
      const response = await configAxios.get(
        `/products/getCitiesOfRegion?id_regiao=${idregiao}&nomemun=${nomemun}`
      );
      if (response.data.length > 0) {
        return true;
      }
      return false;
    } catch {
      NotificationManager.error(
        'Tivemos dificuldades buscar as cidades da região no momento, por favor tente novamente!',
        'Atenção'
      );
    }
  }

  function CalculeValuesClient() {
    if (!infosDeps.dtnascimento) {
      NotificationManager.warning(
        'Por favor, preencha a data de nascimento para calcular!',
        'Atenção'
      );
      return;
    }
    let infosSales;

    if (infoState.multiplosplanos === 'Sim' && props.otherInfos.id_type_client !== 1) {
      infosSales = {
        codtab: infosDeps.codtab,
        datanascimento: infosDeps.dtnascimento
      };
    } else {
      infosSales = {
        codtab: props.otherInfos.codtab,
        datanascimento: infosDeps.dtnascimento
      };
    }
    configAxios
      .post('utilsInfos/calculeSales', infosSales)
      .then((response) => {
        infosDeps.valclient = response.data;
        setSalesValue(response.data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para calcular o plano no momento, tente novamente!',
          'Atenção'
        );
      });
  }

  // Busca o CNS automaticamente via API usando CPF e data de nascimento
  function buscarCNS() {
    if (!infosDeps.cpf_cnpj) {
      NotificationManager.warning('Por favor, preencha o CPF antes de buscar o CNS!', 'Atenção');
      return;
    }

    if (!infosDeps.dtnascimento) {
      NotificationManager.warning(
        'Por favor, preencha a data de nascimento antes de buscar o CNS!',
        'Atenção'
      );
      return;
    }

    const dataNascimentoFormatada = infosDeps.dtnascimento.split('-').reverse().join('/');

    const dadosBusca = {
      cpf: infosDeps.cpf_cnpj,
      dataNascimento: dataNascimentoFormatada
    };

    configAxios
      .post('/integration/cns', dadosBusca)
      .then((response) => {
        if (
          response.data.cns &&
          typeof response.data.cns === 'string' &&
          response.data.cns.length === 15
        ) {
          const novosDeps = { ...infosDeps };
          novosDeps.cns = response.data.cns;
          setInfosDeps(novosDeps);
          NotificationManager.success('CNS encontrado com sucesso!', 'Sucesso');
        } else {
          NotificationManager.warning('CNS não encontrado para os dados informados.', 'Atenção');
        }
      })
      .catch(() => {
        NotificationManager.error(
          'Erro ao buscar CNS. Verifique os dados e tente novamente.',
          'Erro'
        );
      });
  }

  async function buscarDadosDirectData(cpf) {
    if (!cpf || cpfBuscado === cpf) return;

    try {
      const response = await configAxios.get('/directdata/cpf', {
        params: { cpf }
      });

      if (response.status === 202) {
        NotificationManager.warning(response.data, 'Atenção');
        return;
      }

      if (response.data && response.data.retorno) {
        const dados = response.data.retorno;
        let dataNascimento = '';
        if (dados.dataNascimento) {
          const partes = dados.dataNascimento.split('/');
          // console.log(partes);
          if (partes.length === 3) {
            dataNascimento = `${partes[2].split(' ')[0]}-${partes[1]}-${partes[0]}`;
          }
        }
        const dadosPreenchidos = {
          ...infosDeps,
          cpf_cnpj: cpf,
          nome: dados.nome || infosDeps.nome,
          dtnascimento: dataNascimento || infosDeps.dtnascimento,
          nomedamae: dados.nomeMae || infosDeps.nomemae,
          sexo: dados.sexo || infosDeps.sexo
        };

        setInfosDeps(dadosPreenchidos);
        setCpfBuscado(cpf);

        validDtnascimento(dadosPreenchidos.dtnascimento);

        // NotificationManager.success('Dados preenchidos automaticamente pelo DirectData', 'Sucesso');
      }
    } catch (error) {
      NotificationManager.warning(
        'Tivemos dificuldades para buscar a as informações, tente novamente!',
        'Atenção'
      );
    }
  }

  async function consultaBlacklist(cpf) {
    try {
      const response = await configAxios.get('/blacklist/cpf', {
        params: { cpf }
      });

      return response;
    } catch (error) {
      NotificationManager.warning(
        'Tivemos dificuldades para consultar a blacklist, tente novamente!',
        'Atenção'
      );
      return { status: 500 };
    }
  }

  async function validCPF(event) {
    if (event.target.value) {
      const cpfIsValid = validateCPF(event.target.value);
      if (!cpfIsValid) {
        NotificationManager.warning('CPF inválido, por favor verifique!', 'Atenção');
        setInfosDeps({ ...infosDeps, cpf_cnpj: '' });
        return;
      }

      // Consulta blacklist
      if (cpfBuscado !== event.target.value && infoState.consultablacklist === 'Sim') {
        const res = await consultaBlacklist(event.target.value);
        if (res.status === 202) {
          NotificationManager.warning(
            'Não é possível continuar o cadastro com esse CPF, favor verificar com a operadora/administradora!',
            'Atenção'
          );
          setInfosDeps({ ...infosDeps, cpf_cnpj: '' });
          return;
        }
        if (res.status === 500) {
          setInfosDeps({ ...infosDeps, cpf_cnpj: '' });
          return;
        }
      }

      if (cpfBuscado !== event.target.value && infoState.integradirectdata === 'Sim') {
        await buscarDadosDirectData(event.target.value);
      } else {
        setInfosDeps({ ...infosDeps, [event.target.name]: event.target.value });
      }
    }
  }

  function calcularIdade(dataNascimento) {
    if (!dataNascimento) return null;
    const hoje = new Date();
    const nascimento = new Date(dataNascimento);
    let idade = hoje.getFullYear() - nascimento.getFullYear();
    const mes = hoje.getMonth() - nascimento.getMonth();
    if (mes < 0 || (mes === 0 && hoje.getDate() < nascimento.getDate())) {
      idade--;
    }
    return idade;
  }

  function validDtnascimento(dataNascimento = null) {
    infosDeps.dtnascimento = dataNascimento ? dataNascimento : infosDeps.dtnascimento;

    if (infosDeps.dtnascimento > new Date().toLocaleDateString().split('/').reverse().join('-')) {
      NotificationManager.warning('Por favor, escolha uma data de nascimento válida!', 'Atenção');
      setInfosDeps({ ...infosDeps, dtnascimento: null });
      infosDeps.dtnascimento = '';
      return;
    }
    if (props.otherInfos.tpcontrat == '3-COLETIVO POR ADESAO') {
      if (props.otherInfos.idademinima) {
        const idade = calcularIdade(infosDeps.dtnascimento);
        if (props.otherInfos.idademinima > idade) {
          NotificationManager.warning(
            'Não é possível realizar a venda para essa idade utilizando essa associação, verifique!',
            'Atenção'
          );
          setInfosDeps({ ...infosDeps, dtnascimento: null });
          infosDeps.dtnascimento = '';
        }
      }
    }
    return;
  }

  function HandleUpdateEmail(event) {
    if (infosDeps.id) {
      if (validEmail(event.target.value)) {
        const wEmail = event.target.name;
        if (event && initialInfosDeps[wEmail] !== event.target.value) {
          const infosUpdate = {
            id: infosDeps.id,
            [event.target.name]: event.target.value,
            user_id: infoState.id
          };
          configAxios
            .post('/clients/updateEmailDep', infosUpdate)
            .then(() => {
              NotificationManager.success('Email atualizado com sucesso!', 'Sucesso');
              setInfosDeps({ ...infosDeps, [event.target.name]: event.target.value });
              initialInfosDeps[wEmail] = event.target.value;
            })
            .catch(() => {
              NotificationManager.error(
                'Tivemos dificuldades para atualizar o email, tente novamente!',
                'Atenção'
              );
            });
        }
      } else {
        NotificationManager.error(
          'Email inválido, por favor, verifique e tente novamente!',
          'Atenção'
        );
      }
    }
  }

  function HandleSubmit(event) {
    event.preventDefault();

    if (props.otherInfos.statusvenda === 'Aguardando cliente' && props.ountSigningDocuments > 0) {
      NotificationManager.warning(
        'Não é possível fazer isso em uma venda em que as assinaturas já tenham sido iniciadas!!',
        'Atenção'
      );
      return;
    }

    if (!infosDeps.valclient) {
      NotificationManager.warning('Por favor, faça o cálculo do valor do beneficiário!', 'Atenção');
      return;
    }

    const qtdDepsTitular = (props.infosDeps || []).filter(
      (d) => d.tpbenef === 'Dependente' && d.id_tit === infosDeps.id_tit && d.id !== infosDeps.id
    ).length;
    if (
      props.otherInfos.tpcontrat_client === '2-COLETIVO EMPRESARIAL' &&
      infosDeps.tpbenef === 'Dependente' &&
      infosDeps.id_tit &&
      qtdDepsTitular >= 6
    ) {
      NotificationManager.warning('Só é permitido no máximo 6 dependentes por titular!', 'Atenção');
      return;
    }

    infosDeps.id_client = props.otherInfos.id;
    infosDeps.typeCad = props.otherInfos.id_type_client === 2 ? 'jurídico' : 'físico';
    const router = infosDeps.id ? 'clients/updateClientDependent' : 'clients/addClientDependent';

    if (props.otherInfos.allow_additive === 'S' && router === 'clients/addClientDependent') {
      infosDeps.included_for_additive = true;
    }
    configAxios
      .post(router, { infosDeps })
      .then((response) => {
        if (response.status === 202) {
          NotificationManager.warning(
            response.data || 'Só é permitido um titular por contrato pessoa física!',
            'Atenção'
          );
          return;
        }
        NotificationManager.success(
          infosDeps.id ? 'Proposta atualizada com sucesso!' : 'Cadastro realizado com sucesso!',
          'Sucesso'
        );
        props.setOpenModal(false);
        props.functionGrid();
        setSalesValue('');
        setInfosDeps({});
        if (infosDeps.typeCad === 'jurídico') {
          getDepsHolder();
        }
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para atender a requisição no momento, tente novamente!',
          'Atenção'
        );
      });
  }

  const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;
    return (
      <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 10,
              top: 8,
              color: (theme) => theme.palette.grey[500]
            }}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  };

  BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired
  };

  return (
    <>
      <div>
        <BootstrapDialog
          onClose={() => {
            props.setOpenModal(false);
            props.functionGrid();
            setInfosDeps({});
          }}
          aria-labelledby="customized-dialog-title"
          fullWidth
          maxWidth={'md'}
          open={props.openModal}>
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={() => {
              props.setOpenModal(false);
              props.functionGrid();
              setInfosDeps({});
            }}>
            {props.otherInfos.id_type_client === 1
              ? infosDeps.id
                ? 'Atualizar dependente'
                : 'Cadastrar dependente'
              : infosDeps.id
              ? 'Atualizar beneficiário'
              : 'Cadastrar beneficiário'}
          </BootstrapDialogTitle>
          <form onSubmit={HandleSubmit}>
            <DialogContent dividers>
              <Grid container spacing={2} sx={{ mb: 1 }}>
                <Grid item xs={12} md={3} sx={{ mt: 1 }}>
                  <InputLabel id="label" sx={{ fontSize: '13px' }}>
                    Tipo de beneficiário *
                  </InputLabel>
                  <Select
                    name="tpbenef"
                    disabled={props.otherInfos.id_type_client === 2 && infosDeps.id ? true : false}
                    fullWidth
                    size="small"
                    required
                    value={infosDeps.tpbenef || ''}
                    onChange={(event) => HandleInputChange(event)}>
                    <MenuItem value={'Titular'}>Titular</MenuItem>
                    {props.otherInfos.id_type_client === 1 && (
                      <MenuItem value={'Titular menor'}>Titular menor</MenuItem>
                    )}
                    <MenuItem value={'Dependente'}>Dependente</MenuItem>
                  </Select>
                </Grid>
                {props.otherInfos.id_type_client === 2 && infosDeps.tpbenef == 'Dependente' && (
                  <Grid item xs={12} md={4} sx={{ mt: 1 }}>
                    <InputLabel id="label" sx={{ fontSize: '13px' }}>
                      Selecione o titular *
                    </InputLabel>
                    <Autocomplete
                      options={infosDepsList}
                      renderOption={(props, option) => <li {...props}>{option.label}</li>}
                      isOptionEqualToValue={(option, value) =>
                        value ? option.label === value : option.label === ''
                      }
                      onChange={(event, value) => HandleAdressTit(value)}
                      value={infosDeps.labelDeps || infosAdressTit.labelDeps || ''}
                      defaultValue=""
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="id_tit"
                          fullWidth
                          size="small"
                          variant="outlined"
                          required
                        />
                      )}
                    />
                  </Grid>
                )}
              </Grid>
              <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={12} md={4}>
                  <InputMask
                    mask="999.999.999-99"
                    value={infosDeps.cpf_cnpj || ''}
                    onChange={(event) => HandleInputChange(event)}
                    onBlur={(event) => validCPF(event)}>
                    {() => (
                      <TextField
                        name="cpf_cnpj"
                        fullWidth
                        label="CPF"
                        required
                        variant="outlined"
                        size="small"
                      />
                    )}
                  </InputMask>
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    name="nome"
                    fullWidth
                    label="Nome completo"
                    variant="outlined"
                    size="small"
                    required
                    value={infosDeps.nome || ''}
                    inputProps={{ maxLength: 100 }}
                    onChange={(event) => HandleInputChange(event)}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    name="nomesocial"
                    fullWidth
                    label="Nome social"
                    variant="outlined"
                    size="small"
                    value={infosDeps.nomesocial || ''}
                    inputProps={{ maxLength: 100 }}
                    onChange={(event) => HandleInputChange(event)}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={12} md={4}>
                  <TextField
                    name="dtnascimento"
                    label="Data de nascimento"
                    fullWidth
                    type="date"
                    required
                    variant="outlined"
                    size="small"
                    value={infosDeps.dtnascimento || ''}
                    onChange={(event) => HandleInputChange(event)}
                    onBlur={() => validDtnascimento()}
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    name="rg"
                    label="RG"
                    fullWidth
                    placeholder="Ex: 99.999.999-9"
                    // required
                    variant="outlined"
                    size="small"
                    value={infosDeps.rg || ''}
                    inputProps={{ maxLength: 20 }}
                    onChange={(event) => HandleInputChange(event)}
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Autocomplete
                    options={infosOrgaEmissor}
                    renderOption={(props, option) => <li {...props}>{option.label}</li>}
                    isOptionEqualToValue={(option, value) =>
                      value ? option.label === value : option.label === ''
                    }
                    onChange={(event, value) => HandleInputChange(value, { autocomplete: true })}
                    value={infosDeps.label || ''}
                    defaultValue=""
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Orgão emissor"
                        name="orgao_emissor"
                        fullWidth
                        size="small"
                        variant="outlined"
                        // required
                      />
                    )}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid
                  item
                  xs={12}
                  md={props.otherInfos.tpcontrat_client === '3-COLETIVO POR ADESAO' ? 3 : 4}>
                  <InputMask
                    mask="(99)99999-9999"
                    value={infosDeps.celular || ''}
                    onChange={(event) => HandleInputChange(event)}>
                    {() => (
                      <TextField
                        name="celular"
                        fullWidth
                        label="Celular"
                        variant="outlined"
                        size="small"
                        required
                      />
                    )}
                  </InputMask>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={props.otherInfos.tpcontrat_client === '3-COLETIVO POR ADESAO' ? 3 : 4}>
                  <InputMask
                    mask="(99)9999-9999"
                    onChange={(event) => HandleInputChange(event)}
                    value={infosDeps.telefone || ''}>
                    {() => (
                      <TextField
                        name="telefone"
                        fullWidth
                        label="Telefone residencial"
                        variant="outlined"
                        size="small"
                      />
                    )}
                  </InputMask>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={props.otherInfos.tpcontrat_client === '3-COLETIVO POR ADESAO' ? 3 : 4}>
                  <TextField
                    name="email"
                    fullWidth
                    label="Email"
                    required
                    size="small"
                    type="email"
                    variant="outlined"
                    value={infosDeps.email || ''}
                    inputProps={{ maxLength: 50, style: { textTransform: 'lowerCase' } }}
                    onChange={(event) => HandleInputChange(event)}
                    onBlur={(event) => HandleUpdateEmail(event)}
                  />
                </Grid>
                {props.otherInfos.tpcontrat_client === '3-COLETIVO POR ADESAO' && (
                  <Grid item xs={12} md={3}>
                    <TextField
                      name="profissao_dep"
                      fullWidth
                      label="Profissão"
                      size="small"
                      variant="outlined"
                      inputProps={{ maxLength: 100 }}
                      value={infosDeps.profissao_dep || ''}
                      onChange={(event) => HandleInputChange(event)}
                    />
                  </Grid>
                )}
              </Grid>
              <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={12} md={4}>
                  <TextField
                    name="nomedamae"
                    fullWidth
                    label="Nome da mãe"
                    size="small"
                    variant="outlined"
                    required
                    value={infosDeps.nomedamae || ''}
                    inputProps={{ maxLength: 100 }}
                    onChange={(event) => HandleInputChange(event)}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    name="cns"
                    fullWidth
                    label="Cartão nacional do SUS"
                    size="small"
                    variant="outlined"
                    required
                    value={infosDeps.cns || ''}
                    inputProps={{ maxLength: 15 }}
                    onChange={(event) => HandleInputChange(event)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={buscarCNS}
                            edge="end"
                            size="small"
                            title="Buscar CNS automaticamente">
                            <Iconify icon="eva:search-outline" />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    name="decnascidovivo"
                    fullWidth
                    label="Declaração de nascido vivo"
                    size="small"
                    variant="outlined"
                    value={infosDeps.decnascidovivo || ''}
                    inputProps={{ maxLength: 12 }}
                    onChange={(event) => HandleInputChange(event)}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ mt: 0.1 }}>
                {infosDeps.tpbenef === 'Dependente' &&
                  props.otherInfos.id_type_client == 1 &&
                  company === 'bemconecta' && (
                    <Grid item xs={12} md={2}>
                      <InputLabel id="label" sx={{ fontSize: '13px' }}>
                        Parentesco *
                      </InputLabel>
                      <Select
                        name="parentesco"
                        fullWidth
                        size="small"
                        required
                        value={infosDeps.parentesco || ''}
                        onChange={(event) => HandleInputChange(event)}>
                        {/* <MenuItem value={'Filho(a)'}>Filho(a)</MenuItem>
                        <MenuItem value={'Conjuge'}>Conjuge</MenuItem> */}
                        <MenuItem value={'Pai'}>Pai</MenuItem>
                        <MenuItem value={'Mãe'}>Mãe</MenuItem>
                        <MenuItem value={'Filho(a)'}>Filho(a)</MenuItem>
                        <MenuItem value={'Conjuge'}>Conjuge</MenuItem>
                        <MenuItem value={'Enteado'}>Enteado(a)</MenuItem>
                        <MenuItem value={'Dep. Especial'}>Dep. especial</MenuItem>
                        <MenuItem value={'Outros'}>Outros</MenuItem>
                      </Select>
                    </Grid>
                  )}
                {infosDeps.tpbenef === 'Dependente' &&
                  props.otherInfos.id_type_client !== 1 &&
                  company === 'bemconecta' && (
                    <Grid item xs={12} md={2}>
                      <InputLabel id="label" sx={{ fontSize: '13px' }}>
                        Parentesco *
                      </InputLabel>
                      <Select
                        name="parentesco"
                        fullWidth
                        size="small"
                        required
                        value={infosDeps.parentesco || ''}
                        onChange={(event) => HandleInputChange(event)}>
                        {/* <MenuItem value={'Filho(a)'}>Filho(a)</MenuItem>
                        <MenuItem value={'Conjuge'}>Conjuge</MenuItem> */}
                        <MenuItem value={'Pai'}>Pai</MenuItem>
                        <MenuItem value={'Mãe'}>Mãe</MenuItem>
                        <MenuItem value={'Filho(a)'}>Filho(a)</MenuItem>
                        <MenuItem value={'Conjuge'}>Conjuge</MenuItem>
                        <MenuItem value={'Enteado'}>Enteado(a)</MenuItem>
                        <MenuItem value={'Dep. Especial'}>Dep. especial</MenuItem>
                        <MenuItem value={'Outros'}>Outros</MenuItem>
                      </Select>
                    </Grid>
                  )}
                {infosDeps.tpbenef === 'Dependente' &&
                  props.otherInfos.id_type_client == 1 &&
                  company === 'higiasaude' && (
                    <Grid item xs={12} md={2}>
                      <InputLabel id="label" sx={{ fontSize: '13px' }}>
                        Parentesco *
                      </InputLabel>
                      <Select
                        name="parentesco"
                        fullWidth
                        size="small"
                        required
                        value={infosDeps.parentesco || ''}
                        onChange={(event) => HandleInputChange(event)}>
                        {/* <MenuItem value={'Filho(a)'}>Filho(a)</MenuItem>
                        <MenuItem value={'Conjuge'}>Conjuge</MenuItem> */}
                        {/* <MenuItem value={'Pai'}>Pai</MenuItem>
                        <MenuItem value={'Mãe'}>Mãe</MenuItem> */}
                        <MenuItem value={'Filho(a)'}>Filho(a)</MenuItem>
                        <MenuItem value={'Conjuge'}>Conjuge</MenuItem>
                        <MenuItem value={'Enteado'}>Enteado(a)</MenuItem>
                        {/* <MenuItem value={'Dep. Especial'}>Dep. especial</MenuItem> */}
                        <MenuItem value={'Outros'}>Outros</MenuItem>
                      </Select>
                    </Grid>
                  )}
                {infosDeps.tpbenef === 'Dependente' &&
                  props.otherInfos.id_type_client !== 1 &&
                  company === 'higiasaude' && (
                    <Grid item xs={12} md={2}>
                      <InputLabel id="label" sx={{ fontSize: '13px' }}>
                        Parentesco *
                      </InputLabel>
                      <Select
                        name="parentesco"
                        fullWidth
                        size="small"
                        required
                        value={infosDeps.parentesco || ''}
                        onChange={(event) => HandleInputChange(event)}>
                        {/* <MenuItem value={'Filho(a)'}>Filho(a)</MenuItem>
                        <MenuItem value={'Conjuge'}>Conjuge</MenuItem> */}
                        {/* <MenuItem value={'Pai'}>Pai</MenuItem>
                        <MenuItem value={'Mãe'}>Mãe</MenuItem> */}
                        <MenuItem value={'Filho(a)'}>Filho(a)</MenuItem>
                        <MenuItem value={'Conjuge'}>Conjuge</MenuItem>
                        <MenuItem value={'Enteado'}>Enteado(a)</MenuItem>
                        {/* <MenuItem value={'Dep. Especial'}>Dep. especial</MenuItem> */}
                        <MenuItem value={'Outros'}>Outros</MenuItem>
                      </Select>
                    </Grid>
                  )}
                {infosDeps.tpbenef === 'Dependente' &&
                  props.otherInfos.id_type_client !== 1 &&
                  company !== 'bemconecta' &&
                  company !== 'higiasaude' && (
                    <Grid item xs={12} md={2}>
                      <InputLabel id="label" sx={{ fontSize: '13px' }}>
                        Parentesco *
                      </InputLabel>
                      <Select
                        name="parentesco"
                        fullWidth
                        size="small"
                        required
                        value={infosDeps.parentesco || ''}
                        onChange={(event) => HandleInputChange(event)}>
                        <MenuItem value={'Pai'}>Pai</MenuItem>
                        <MenuItem value={'Mãe'}>Mãe</MenuItem>
                        <MenuItem value={'Filho(a)'}>Filho(a)</MenuItem>
                        <MenuItem value={'Conjuge'}>Conjuge</MenuItem>
                        <MenuItem value={'Enteado'}>Enteado(a)</MenuItem>
                        <MenuItem value={'Dep. Especial'}>Dep. especial</MenuItem>
                        <MenuItem value={'Outros'}>Outros</MenuItem>
                      </Select>
                    </Grid>
                  )}
                {infosDeps.tpbenef === 'Dependente' &&
                  props.otherInfos.id_type_client == 1 &&
                  company !== 'bemconecta' &&
                  company !== 'higiasaude' && (
                    <Grid item xs={12} md={2}>
                      <InputLabel id="label" sx={{ fontSize: '13px' }}>
                        Parentesco *
                      </InputLabel>
                      <Select
                        name="parentesco"
                        fullWidth
                        size="small"
                        required
                        value={infosDeps.parentesco || ''}
                        onChange={(event) => HandleInputChange(event)}>
                        <MenuItem value={'Pai'}>Pai</MenuItem>
                        <MenuItem value={'Mãe'}>Mãe</MenuItem>
                        <MenuItem value={'Filho(a)'}>Filho(a)</MenuItem>
                        <MenuItem value={'Conjuge'}>Conjuge</MenuItem>
                        <MenuItem value={'Enteado'}>Enteado(a)</MenuItem>
                        <MenuItem value={'Dep. Especial'}>Dep. especial</MenuItem>
                        <MenuItem value={'Outros'}>Outros</MenuItem>
                      </Select>
                    </Grid>
                  )}
                <Grid
                  item
                  xs={12}
                  md={
                    infosDeps.tpbenef === 'Dependente' && props.otherInfos.id_type_client !== 1
                      ? 3
                      : 3
                  }>
                  <InputLabel id="label" sx={{ fontSize: '13px' }}>
                    Sexo *
                  </InputLabel>
                  <Select
                    name="sexo"
                    fullWidth
                    size="small"
                    required
                    value={infosDeps.sexo || ''}
                    onChange={(event) => HandleInputChange(event)}>
                    <MenuItem value={'Masculino'}>Masculino</MenuItem>
                    <MenuItem value={'Feminino'}>Feminino</MenuItem>
                    <MenuItem value={'Outros'}>Outros</MenuItem>
                  </Select>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={
                    infosDeps.tpbenef === 'Dependente' && props.otherInfos.id_type_client !== 1
                      ? 3
                      : 3
                  }>
                  <InputLabel id="label" sx={{ fontSize: '13px' }}>
                    Estado civil *
                  </InputLabel>
                  <Select
                    name="estadocivil"
                    fullWidth
                    size="small"
                    required
                    value={infosDeps.estadocivil || ''}
                    onChange={(event) => HandleInputChange(event)}>
                    <MenuItem value={'Solteiro(a)'}>Solteiro(a)</MenuItem>
                    <MenuItem value={'Casado(a)'}>Casado(a)</MenuItem>
                    <MenuItem value={'Divorciado(a)'}>Divorciado(a)</MenuItem>
                    <MenuItem value={'Viuvo(a)'}>Viuvo(a)</MenuItem>
                    {infoState.tipo !== 'Complexo' && (
                      <MenuItem value={'Companheiro(a)'}>Companheiro(a)</MenuItem>
                    )}
                  </Select>
                </Grid>
                {infoState.multiplosplanos === 'Sim' && props.otherInfos.id_type_client !== 1 && (
                  <>
                    <Grid
                      item
                      xs={12}
                      md={
                        infosDeps.tpbenef === 'Dependente' && props.otherInfos.id_type_client !== 1
                          ? 4
                          : 5
                      }>
                      <InputLabel id="label" sx={{ fontSize: '13px' }}>
                        Produto/Plano *
                      </InputLabel>
                      <Autocomplete
                        options={props.infosPlans}
                        renderOption={(props, option) => <li {...props}>{option.label}</li>}
                        isOptionEqualToValue={(option, value) =>
                          value ? option.label === value : option.label === ''
                        }
                        onChange={(event, value) => HandleInputChange(value, { plan: true })}
                        value={infosDeps.labelplans || ''}
                        defaultValue=""
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            name="codplano"
                            fullWidth
                            size="small"
                            variant="outlined"
                            required
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} md={5}>
                      <InputLabel id="label" sx={{ fontSize: '13px' }}>
                        Tabela *
                      </InputLabel>
                      <Autocomplete
                        options={infosTablesTemp}
                        renderOption={(props, option) => <li {...props}>{option.label}</li>}
                        isOptionEqualToValue={(option, value) =>
                          value ? option.label === value : option.label === ''
                        }
                        onChange={(event, value) => HandleInputChange(value, { table: true })}
                        value={infosDeps.labeltables || ''}
                        defaultValue=""
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            name="codtab"
                            fullWidth
                            size="small"
                            variant="outlined"
                            required
                          />
                        )}
                      />
                    </Grid>
                  </>
                )}
                {(infoState.multiplosplanos === 'Não' || props.otherInfos.id_type_client === 1) && (
                  <>
                    <Grid
                      item
                      xs={12}
                      md={
                        infosDeps.tpbenef === 'Dependente' && props.otherInfos.id_type_client !== 1
                          ? 4
                          : 4
                      }>
                      <InputLabel id="label" sx={{ fontSize: '13px' }}>
                        Produto/Plano *
                      </InputLabel>
                      <TextField
                        name="codplano"
                        fullWidth
                        disabled
                        required
                        size="small"
                        variant="outlined"
                        value={props.otherInfos.labelplans || ''}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={
                        infosDeps.tpbenef === 'Dependente' && props.otherInfos.id_type_client !== 1
                          ? 4
                          : 4
                      }>
                      <InputLabel id="label" sx={{ fontSize: '13px' }}>
                        Tabela *
                      </InputLabel>
                      <TextField
                        name="codtab"
                        fullWidth
                        disabled
                        required
                        size="small"
                        variant="outlined"
                        value={props.otherInfos.labeltables || ''}
                      />
                    </Grid>
                  </>
                )}
                {infoState.tipooperacao !== 'Odonto' && (
                  <Grid item xs={12} md={props.otherInfos.id_type_client === 1 ? 3 : 3}>
                    <InputLabel id="label" sx={{ fontSize: '13px' }}>
                      Carência do beneficiário *
                    </InputLabel>
                    <Autocomplete
                      options={
                        props.otherInfos.formato === '2-29' && company === 'higiasaude'
                          ? infosWaitingPeriod.filter((option) => option.codcarencia !== '0000027')
                          : infosWaitingPeriod
                      }
                      renderOption={(props, option) => <li {...props}>{option.label}</li>}
                      isOptionEqualToValue={(option, value) =>
                        value ? option.label === value : option.label === ''
                      }
                      onChange={(event, value) => HandleInputChange(value, { codcarencia: true })}
                      value={infosDeps.labelcarencia || ''}
                      defaultValue=""
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="codcarencia"
                          fullWidth
                          size="small"
                          variant="outlined"
                          required
                        />
                      )}
                    />
                  </Grid>
                )}
                <Grid item xs={12} md={props.otherInfos.id_type_client === 1 ? 3 : 2}>
                  <InputLabel id="label" sx={{ fontSize: '13px' }}>
                    Valor *
                  </InputLabel>
                  <TextField
                    name="valclient"
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={`R$ ${infosDeps.valclient || salesValue}`}
                    InputProps={{
                      readOnly: true
                    }}
                  />
                </Grid>

                {isMobile && (
                  <Grid item xs={12}>
                    <Stack direction="row" alignItems="center" justifyContent="end">
                      <Button
                        sx={!isMobile ? { mt: 2.7 } : { mt: 1 }}
                        variant="contained"
                        color="success"
                        onClick={CalculeValuesClient}
                        startIcon={<Iconify icon="ant-design:calculator-outlined" />}>
                        Calcular
                      </Button>
                    </Stack>
                  </Grid>
                )}
                {!isMobile && (
                  <Grid item xs={2} md={2}>
                    <Button
                      sx={!isMobile ? { mt: 2.7 } : { mt: 1 }}
                      variant="contained"
                      color="success"
                      onClick={CalculeValuesClient}
                      startIcon={<Iconify icon="ant-design:calculator-outlined" />}>
                      Calcular
                    </Button>
                  </Grid>
                )}
              </Grid>
              {props.otherInfos.allow_additive === 'S' && (
                <>
                  <Grid container spacing={2} sx={{ mt: 1 }}>
                    <Grid item xs={12} md={4}>
                      <TextField
                        name="dtmensalidade"
                        label="Data da primeira mensalidade"
                        fullWidth
                        type="date"
                        required
                        variant="outlined"
                        size="small"
                        value={infosDeps.dtmensalidade || ''}
                        onChange={(event) => HandleInputChange(event)}
                        InputLabelProps={{
                          shrink: true
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        name="dtreferenciaanterior"
                        label="Data da referência anterior"
                        fullWidth
                        type="date"
                        required
                        variant="outlined"
                        size="small"
                        value={infosDeps.dtreferenciaanterior || ''}
                        onChange={(event) => HandleInputChange(event)}
                        InputLabelProps={{
                          shrink: true
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        name="dtvigenciadep"
                        label="Data da vigência do dependente"
                        fullWidth
                        type="date"
                        required
                        variant="outlined"
                        size="small"
                        value={infosDeps.dtvigenciadep || ''}
                        onChange={(event) => HandleInputChange(event)}
                        InputLabelProps={{
                          shrink: true
                        }}
                      />
                    </Grid>
                  </Grid>
                </>
              )}
              {props.otherInfos.id_type_client === 2 && (
                <>
                  <Grid container spacing={2} sx={{ mt: 1 }}>
                    <Grid item xs={12} md={2}>
                      <InputMask
                        mask="99999-999"
                        disabled={infosDeps.tpbenef === 'Dependente' ? true : false}
                        onChange={(event) => HandleInputChange(event)}
                        onBlur={(event) => HandleInputCep(event)}
                        value={infosDeps.cep || infosAdressTit.cep || ''}>
                        {() => (
                          <TextField
                            name="cep"
                            fullWidth
                            disabled={infosDeps.tpbenef === 'Dependente' ? true : false}
                            label="CEP"
                            variant="outlined"
                            size="small"
                            required
                          />
                        )}
                      </InputMask>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        name="rua"
                        fullWidth
                        label="Rua"
                        required
                        size="small"
                        disabled={infosDeps.tpbenef === 'Dependente' ? true : false}
                        variant="outlined"
                        onChange={(event) => HandleInputChange(event)}
                        value={infosDeps.rua || infosAdressTit.rua || ''}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <TextField
                        name="numero"
                        fullWidth
                        label="Número"
                        value={infosDeps.numero || infosAdressTit.numero || ''}
                        required
                        disabled={infosDeps.tpbenef === 'Dependente' ? true : false}
                        size="small"
                        variant="outlined"
                        type="text"
                        onChange={(event) => HandleInputChange(event)}
                        inputProps={{ maxLength: 5 }}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <TextField
                        name="complemento"
                        fullWidth
                        disabled={infosDeps.tpbenef === 'Dependente' ? true : false}
                        label="Complemento"
                        size="small"
                        value={infosDeps.complemento || infosAdressTit.complemento || ''}
                        variant="outlined"
                        onChange={(event) => HandleInputChange(event)}
                        inputProps={{ maxLength: 100 }}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} sx={{ mt: 1 }}>
                    <Grid item xs={12} md={4}>
                      <TextField
                        name="bairro"
                        fullWidth
                        label="Bairro"
                        disabled={infosDeps.tpbenef === 'Dependente' ? true : false}
                        required
                        size="small"
                        variant="outlined"
                        onChange={(event) => HandleInputChange(event)}
                        value={infosDeps.bairro || infosAdressTit.bairro || ''}
                        inputProps={{ maxLength: 100 }}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        name="cidade"
                        fullWidth
                        label="Cidade"
                        disabled={
                          infoState.id_type_user === 1 && infosDeps.tpbenef !== 'Dependente'
                            ? false
                            : true
                        }
                        variant="outlined"
                        size="small"
                        required
                        value={infosDeps.cidade || infosAdressTit.cidade || ''}
                        onChange={(event) => HandleInputChange(event)}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        name="estado"
                        fullWidth
                        label="Estado"
                        disabled={
                          infoState.id_type_user === 1 && infosDeps.tpbenef !== 'Dependente'
                            ? false
                            : true
                        }
                        required
                        size="small"
                        variant="outlined"
                        value={infosDeps.estado || infosAdressTit.estado || ''}
                        onChange={(event) => HandleInputChange(event)}
                      />
                    </Grid>
                  </Grid>
                </>
              )}
            </DialogContent>
            <DialogActions sx={{ mt: 2 }}>
              <Button
                color="success"
                variant="contained"
                type="submit"
                disabled={
                  (infoState.id_type_user === 2 && props.otherInfos.statusvenda !== 'Aberta') ||
                  props.otherInfos.statusvenda === 'Aprovada' ||
                  // eslint-disable-next-line prettier/prettier
                  (props.countSigningDocuments > 0 && props.otherInfos.allow_additive === 'N')
                    ? true
                    : false
                }
                startIcon={<Iconify icon="eva:save-fill" />}>
                {infosDeps.id ? 'Atualizar' : 'Salvar'}
              </Button>
              <Button
                onClick={() => {
                  props.setOpenModal(false);
                  setInfosDeps({});
                }}
                color="error"
                variant="contained"
                startIcon={<Iconify icon="eva:close-circle-fill" />}>
                Cancelar
              </Button>
            </DialogActions>
          </form>
        </BootstrapDialog>
      </div>
    </>
  );
};

export default addClientsDependents;
